import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { IfFooterLayout } from 'components/featureFlags/layoutStyle';

const Wrapper = styled.div`
  background-color: ${globalTheme.palette.surface};
  border-top: 1px solid ${globalTheme.palette.backgroundAlt};
  padding: ${globalTheme.spacing.md};
  min-height: 4.5rem;
`;

const Footer = () => {
  return (
    <Wrapper data-test="widget-footer">
      <IfFooterLayout />
    </Wrapper>
  );
};

export default Footer;
